<template lang="pug" src="./home.pug"></template>

<script>
import Loader from 'components/loader/loader'
import HeroHome from 'components/hero/hero-home/hero-home'
import CustomHomeTiles from 'components/custom/custom-home-tiles/custom-home-tiles'
import CustomHomeWelcome from 'components/custom/custom-home-welcome/custom-home-welcome'
import CustomHomeTech from 'components/custom/custom-home-tech/custom-home-tech'
import CustomHomeVideo from 'components/custom/custom-home-video/custom-home-video'
import CustomHomeOffice from 'components/custom/custom-home-office/custom-home-office'
import CustomHomeTestimonials from 'components/custom/custom-home-testimonials/custom-home-testimonials'
import CustomHomeMap from 'components/custom/custom-home-map/custom-home-map'

export default {
  name: 'Home',
  computed: {
    props () {
      return this.$store.state.pages.home
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader,
    HeroHome,
    CustomHomeTiles,
    CustomHomeWelcome,
    CustomHomeTech,
    CustomHomeVideo,
    CustomHomeTestimonials,
    CustomHomeOffice,
    CustomHomeMap
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/home.vue